module.exports = __webpack_public_path__ + "ef88999e445072230fd106c853cbb21b.svg";